module.exports = __webpack_public_path__ + "static/media/storeBanner3.62f2e693.png";